exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".error[data-v-b88ae1bc]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Main/ResetPasswordModal.vue"],"names":[],"mappings":"AACA,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B","file":"ResetPasswordModal.vue","sourcesContent":["\n.error[data-v-b88ae1bc] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b88ae1bc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/ResetPasswordModal.vue
// module id = 1946
// module chunks = 7